/**
 * AutoSpecData wordmark — direction A (weight/tracking contrast) + D (gauge-arc underline).
 * Gold "Spec" in medium weight against extrabold ink "Auto"/"Data", with a thin arc
 * echoing the seal's gauge stroke.
 */
export function Wordmark({ className = "" }: { className?: string }) {
  return (
    <span className={`font-heading whitespace-nowrap pb-[3px] text-lg leading-none ${className}`} style={{ letterSpacing: "-0.018em" }}>
      <span className="font-extrabold">Auto</span>
      <span className="relative inline-block font-medium text-highlight" style={{ letterSpacing: "0.01em" }}>
        Spec
        <svg
          aria-hidden="true"
          viewBox="0 0 40 6"
          preserveAspectRatio="none"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          className="absolute -bottom-[2.5px] left-0 h-[3.6px] w-full"
        >
          <path d="M1 5C6 1.6 34 1.6 39 5" strokeWidth="1.6" />
        </svg>
      </span>
      <span className="font-extrabold">Data</span>
    </span>
  );
}
